import ReactDOM from "react-dom/client";
import {AppProvider} from './Components/App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import { DocumentsProvider } from './Context/DocumentsContext';
import {store} from './Redux/Store/Store';

import { initI18n } from "./i18n";

async function renderApp() {
  await initI18n();

  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <Provider store={store}>
      <DocumentsProvider>
        <AppProvider />
      </DocumentsProvider>
    </Provider>
  );
}

renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
